const InputType = {
    Email: 0,
    Password: 1,
    Alphanumeric: 2,
    Number: 3,
    Other: 4,
    Text: 5,
}

export default InputType